import NavRouteSelectPanel from './src/nav-route-select-panel';

export default NavRouteSelectPanel;
